import { useTranslation } from 'react-i18next';

const KNOWN_CATEGORIES: Array<{ key: string; labelKey: string; match: RegExp }> = [
  { key: 'cdp', labelKey: 'accounts.tech_cat_cdp', match: /salesforce|hubspot|kintone|sfdc/i },
  { key: 'analytics', labelKey: 'accounts.tech_cat_analytics', match: /ga4|amplitude|mixpanel|segment|datadog/i },
  { key: 'productivity', labelKey: 'accounts.tech_cat_productivity', match: /slack|notion|teams|zoom|asana|jira/i },
  { key: 'cloud', labelKey: 'accounts.tech_cat_cloud', match: /aws|gcp|azure|cloudflare/i },
  { key: 'commerce', labelKey: 'accounts.tech_cat_commerce', match: /shopify|stripe|adyen|woocommerce/i },
];

function categorise(tech: string): string {
  for (const c of KNOWN_CATEGORIES) {
    if (c.match.test(tech)) return c.labelKey;
  }
  return 'accounts.tech_cat_other';
}

export function TechStackList({ items }: { items: string[] }) {
  const { t } = useTranslation();

  if (!items || items.length === 0) {
    return (
      <p className="text-xs text-ink-500">{t('accounts.tech_empty')}</p>
    );
  }

  const grouped = new Map<string, string[]>();
  for (const it of items) {
    const cat = categorise(it);
    const list = grouped.get(cat) ?? [];
    list.push(it);
    grouped.set(cat, list);
  }

  return (
    <div className="space-y-3">
      <p className="text-[11px] text-ink-500 leading-relaxed">
        {t('accounts.tech_source_hint')}
      </p>
      {Array.from(grouped.entries()).map(([cat, list]) => (
        <div key={cat}>
          <div className="text-[10px] uppercase tracking-[0.12em] text-ink-500 font-semibold mb-1.5">
            {t(cat)}
          </div>
          <div className="flex flex-wrap gap-1.5">
            {list.map((tech) => (
              <span
                key={tech}
                className="inline-flex items-center text-xs px-2 py-0.5 rounded-full border border-ink-200 bg-ink-50 text-ink-700 num"
              >
                {tech}
              </span>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
